<template>
  <div
    class="relative flex flex-col w-full font-regular p-4 text-gray-900 bg-white rounded-lg shadow-xl shadow-blue-gray-900/5 bg-clip-border dark:bg-gray-800 dark:text-gray-200"
  >
    <!-- Header Section -->
    <h3
      class="block text-xl antialiased font-medium leading-snug tracking-normal dark:text-gray-200"
    >
      Quick Action
    </h3>
    <p
      class="block text-sm font-normal leading-6 text-gray-800 opacity-80 mt-2 antialiased mb-6 dark:text-gray-300"
    >
      Links to help make navigation easy for you.
    </p>

    <!-- Quick Action Buttons -->
    <button
      class="w-full mb-3 flex justify-start gap-4 items-center relative cursor-pointer font-normal text-sm hover:bg-main-50 hover:bg-opacity-80 bg-gray-100/60 rounded-lg py-3 px-4 text-main-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200"
    >
      <span><i class="fa-regular fa-square-plus text-[16px]"></i></span>
      Create New Store
    </button>

    <router-link to="/add-product">
      <button
        class="w-full mb-3 flex justify-start gap-4 items-center relative cursor-pointer font-normal text-sm hover:bg-main-50 hover:bg-opacity-80 bg-gray-100/60 rounded-lg py-3 px-4 text-main-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200"
      >
        <span><i class="fa-solid fa-tag text-[16px]"></i></span>
        Add New Product
      </button>
    </router-link>

    <router-link to="/store-settings">
      <button
        class="w-full mb-3 flex justify-start gap-4 items-center relative cursor-pointer font-normal text-sm hover:bg-main-50 hover:bg-opacity-80 bg-gray-100/60 rounded-lg py-3 px-4 text-main-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200"
      >
        <span><i class="fa-solid fa-anchor-circle-check text-[16px]"></i></span>
        Connect Your Domain
      </button>
    </router-link>

    <router-link to="/product-settings">
      <button
        class="w-full mb-3 flex justify-start gap-4 items-center relative cursor-pointer font-normal text-sm hover:bg-main-50 hover:bg-opacity-80 bg-gray-100/60 rounded-lg py-3 px-4 text-main-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200"
      >
        <span><i class="fa-solid fa-layer-group text-[16px]"></i></span>
        Add Product Collection
      </button>
    </router-link>

    <button
      class="w-full mb-3 flex justify-start gap-4 items-center relative cursor-pointer font-normal text-sm hover:bg-main-50 hover:bg-opacity-80 bg-gray-100/60 rounded-lg py-3 px-4 text-main-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200"
    >
      <span
        ><i class="fa-solid fa-magnifying-glass-chart text-[16px]"></i
      ></span>
      View Ads Insight
    </button>

    <button
      class="w-full mb-3 flex justify-start gap-4 items-center relative cursor-pointer font-normal text-sm hover:bg-main-50 hover:bg-opacity-80 bg-gray-100/60 rounded-lg py-3 px-4 text-main-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200"
    >
      <span><i class="fa-solid fa-shop text-[16px]"></i></span>
      View Store Front
    </button>
  </div>
</template>

<script>
export default {
  name: "QuickActionView",
};
</script>
